import { render } from "./AdminAccounts.vue?vue&type=template&id=1288acec&scoped=true"
import script from "./AdminAccounts.vue?vue&type=script&lang=js"
export * from "./AdminAccounts.vue?vue&type=script&lang=js"

import "./AdminAccounts.vue?vue&type=style&index=0&id=1288acec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1288acec"]])

export default __exports__